<template>
    <div class="mzdh" v-loading="isLoading">
<!--        <h3>-->
<!--            <b>常用网址</b>-->
<!--        </h3>-->
        <ul>
            <li v-for="site in sites" :key="site.id">
<!--                <el-tooltip class="item" popper-class="site-tooltip" effect="dark" placement="bottom">-->
<!--						<div slot="content" style="max-width:300px;">-->
<!--							<span>{{site.name}}</span>-->
<!--							<span>{{site.desc}}</span>-->
<!--						</div>-->
                    <a :href="site.url" target="_blank" rel="nofollow">
                        <div>
<!--                            <img v-if="site.img===undefined" src="../assets/web.png"/>-->
<!--                            <img v-if="site.img!==undefined" :src="'/static/web_icons/' + site.img"/>-->
<!--                            <img v-if="site.img!==undefined" :src="'https://grch37.ensembl.org/favicon.ico'"/>-->
<!--                            <img :src="site.img" onerror="this.src='/static/default-site.png'"/>-->
                        </div>
                        <SiteIcon :url="site.url"/>
                        {{site.name}}</a>
<!--                </el-tooltip>-->
            </li>
            <!-- <li><i class="el-icon-s-tools" @click="dialogVisible=true" style="font-size: 18px; color: #14aab9;display: block; text-align: center;line-height: 28px;    margin-right: 30px;"></i></li> -->
        </ul>
        <ManageCommon
            :visible="dialogVisible"
            :defaultSites="defaultSites"
            :customSites="customSites"
            @close="dialogVisible=false"
            @save="onUpdateCustom"></ManageCommon>
    </div>
</template>

<style scoped>
.mzdh { width: 913px; background: #fff; overflow: hidden; border:#e8e8e8 1px solid;/*  position: relative; */}
/* .mzdh h3 i { display:block; margin:0; padding:0; position: absolute; top:0; right: 10px; z-index: 100;} */
.mzdh h3 { height: 54px; line-height: 54px; color: #666; font-size: 18px; padding: 0 20px; border-bottom: #e8e8e8 1px solid;}
.mzdh h3 a { float: right; color: #14aab9; font-size: 16px;}
.mzdh ul { overflow: hidden; padding: 8px 20px 0 20px;}
.mzdh ul li { float: left; width: 12.5%; line-height: 28px}
.mzdh ul li a { display: inline-block;    text-overflow: ellipsis; overflow: hidden; white-space: nowrap;width: 95px;}
.mzdh ul li img {
    float: left; margin: 5px 5px; width: 15px; height: 15px;
    /*border-radius: 50%;*/
    /*border: 1px solid #14aab980;*/
}
</style>

<script>
import ManageCommon from './ManageCommon.vue'

import request from '@/utils/request'
import cs from "../utils/customSite";
import SiteIcon from "./SiteIcon";

export default {
    data() {
        return {
            isLoading: true,
            dialogVisible: false,
            defaultSites: [],
            customSites: [],
            sites: [],
            icons: [
                { host: 'cn.bio-protocol.org', img: 'Bioconductor.jpg' },
                { host: 'www.encodeproject.org', img: 'Bioconductor.jpg' },
            ],
            iconMap: {
                'cn.bio-protocol.org': 'Bioconductor.jpg',
                'www.encodeproject.org': 'ENCODE.png',
            }
        };
    },
    beforeDestroy() {
        this.$bus.$off('addCommon')
    },
    created() {
        this.$nextTick(() => {
            this.init();
        })
        this.$bus.$on('addCommon', (site) => {
            let oMap = {}
            let cMap = {}
            let origin = this.defaultSites
            let custom = this.customSites
            origin.forEach(element => {
                oMap[element.id] = element
            });
            custom.forEach(element => {
                cMap[element.id] = element
            });

            if(oMap[site.id] != null || cMap[site.id] != null) {
                this.$message({
                    message: '该网址已添加',
                    type: 'warning'
                });
                return
            }

            custom.push(site)
            this.onUpdateCustom(custom)
            this.$message({
                message: '添加成功',
                type: 'success'
            });
        })
    },
    methods: {
        init() {
            this.isLoading = true;
            request({
                url: "api/nav/common",
                method: "get"
            }).then((r) => {
                console.log(r);
                for (const key in r) {
                    if (Object.hasOwnProperty.call(r, key)) {
                        const item = r[key];
                        if (!item.url.startsWith("http://") && !item.url.startsWith("https://")) {
                            item.url = "http://" + item.url;
                        }
                    }
                }
                this.defaultSites = r;
                this.customSites = cs.loadUserCustom()
                this.sites = cs.getFinalList(this.defaultSites, this.customSites)
                this.updateIcons()
                this.isLoading = false;
            }).catch(error => {
                console.log(error);
            });
        },
        onUpdateCustom(customs) {
            console.log(customs)
            this.customSites = customs
            this.sites = cs.getFinalList(this.defaultSites, this.customSites)
            this.updateIcons()
            cs.saveUserCustom(customs)
        },
        updateIcons() {
            for (let i = 0; i < this.sites.length; i++) {
                let site = this.sites[i]

                let cutIndex = site.url.indexOf('/', 8)
                let host
                if(cutIndex > 0) {
                    host = site.url.substr(0, cutIndex)
                } else {
                    host = site.url
                }

                let domain
                if(host.indexOf('//') > -1) {
                    domain = host.split('//')[1]
                } else {
                    domain = host
                }

                site.img = host + '/favicon.ico'
            }
        },
    },
    components: {SiteIcon, ManageCommon }
}
</script>



// WEBPACK FOOTER //
// src/components/CommonSites.vue